/* TODO: move to a global hooks folder */
import { useEffect, RefObject } from "react";
import { View } from "react-native";

export interface CloseOnClickOutside {
  isWeb: boolean;
  refs: RefObject<View>[];
  onPress: () => void;
}

const isTouchDevice =
  typeof window !== "undefined" &&
  typeof navigator !== "undefined" &&
  ("ontouchstart" in window || navigator.maxTouchPoints > 0);

const useCloseOnClickOutside = ({
  isWeb,
  refs,
  onPress
}: CloseOnClickOutside) => {
  useEffect(() => {
    const listener = (e: MouseEvent | TouchEvent) => {
      let clickedInRefs = false;
      if (refs) {
        refs.forEach((ref) => {
          if (
            ref &&
            ref.current &&
            ref.current instanceof HTMLElement &&
            ref.current.contains(e.target as HTMLElement)
          ) {
            clickedInRefs = true;
          }
        });
      }

      if (!clickedInRefs) onPress();
    };

    const eventName = isTouchDevice ? "touchstart" : "click";

    if (isWeb) {
      document.addEventListener(eventName, listener);
    }

    return () => {
      if (isWeb) {
        document.removeEventListener(eventName, listener);
      }
    };
  }, []);
};

export default useCloseOnClickOutside;
